// UserComponent.js
import React, { useEffect, useState } from 'react';
import logo from '../images/kalingarayanrunners_logo.png';
import { useRecoilState } from 'recoil';
import ContactPopup from './Popup';
import { Link, useNavigate } from 'react-router-dom';
import { ActiveEvents } from '../Recoil/ActiveEvents';
import { FaPhoneAlt, FaBars, FaTimes } from 'react-icons/fa';
import moment from 'moment';

function Header() {
  const [isOpen, setIsOpen] = useState(null);
  const [activeEvents, setActiveEvents] = useRecoilState(ActiveEvents);
  const [showRegister, setShowRegister] = useState(true);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    // Check authentication status
    const authToken = sessionStorage.getItem('authToken');
    setIsAuthenticated(Boolean(authToken));
    
    // setCurrentIndex(currIndex.currentIndex)
    let eventURI = process.env.REACT_APP_API_URL +"/Events/GetUpcomingEvents";
    fetch(eventURI , {method: "GET"})
      .then(response => {
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        return response.json();
      })
      .then(data => {
        let events = !!data.EventsType && !data.EventsType[0].ErrorMessage ? data.EventsType : []
        events.forEach(element => {
          if(!!element && !!element.RegistrationEndDate){
            // element.RegistrationEndDate = '2025-08-03T00:00:00';
            const deadline =  !!element && !!element.RegistrationEndDate ? moment(element.RegistrationEndDate).set({ hour: 23, minute: 59, second: 0, millisecond: 0 }) : null;
            let isLastDate =  !!deadline ? moment().isSameOrBefore(deadline) : true
            setShowRegister(isLastDate);
          }
        }); 
        setActiveEvents(events);
        // setLoading(false);
      })
      .catch(error => {
        // setError(error.message);
        // setLoading(false);
      });
  }, []);

  const updateBoollen = (value) => {
    setIsOpen(value);
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  }

  const handleLogout = () => {
    sessionStorage.removeItem('authToken');
    setIsAuthenticated(false);
    setIsMobileMenuOpen(false);
    navigate('/login');
  }

  const handleContactClick = () => {
    updateBoollen(true);
    setIsMobileMenuOpen(false);
  }
  return (
    <div>
          <ContactPopup popup={isOpen} updateValue={(value)=>updateBoollen(value)}/>
          
          {/* Fixed Header Navigation */}
          <header className="fixed top-0 left-0 w-full z-50 bg-white/60 backdrop-blur-xl border-b border-neutral-200/30 shadow-soft transition-all duration-300">
              <div className="container-custom">
                  <div className="flex justify-between items-center py-4">
                      <div className="flex items-center space-x-4">
                        <Link to="/" onClick={closeMobileMenu} className="transition-all duration-300 hover:scale-105 group"> 
                          <img 
                              src= {logo} 
                              alt="Kalingarayan Runners Logo" 
                              className="h-12 md:h-14 w-auto drop-shadow-lg group-hover:drop-shadow-xl transition-all duration-300" 
                          />
                        </Link>
                        <div className="hidden lg:block">
                          <h1 className="text-xl font-bold text-primary-500">Kalingarayan Runners</h1>
                          <p className="text-sm text-neutral-600">Excellence in Motion</p>
                        </div>
                      </div>
                      
                      {/* Desktop Navigation */}
                      <nav className="hidden lg:block">
                      <ul className="flex space-x-1 items-center">
                        <li>
                          <Link to="/" className="relative group text-neutral-700 font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:bg-primary-50 hover:text-primary-600 flex items-center justify-center">
                            <span className="relative z-10">Home</span>
                            <div className="absolute inset-0 bg-gradient-to-r from-primary-500/10 to-primary-600/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          </Link>
                        </li>
                        <li>
                          <Link to="/events" className="relative group text-neutral-700 font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:bg-secondary-50 hover:text-secondary-600 flex items-center justify-center">
                            <span className="relative z-10">Events</span>
                            <div className="absolute inset-0 bg-gradient-to-r from-secondary-500/10 to-secondary-600/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          </Link>
                        </li>
                        <li>
                          <button 
                            className="relative group text-neutral-700 font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:bg-accent-50 hover:text-accent-600 flex items-center justify-center"
                            onClick={handleContactClick}
                          >
                            <span className="relative z-10">Contact</span>
                            <div className="absolute inset-0 bg-gradient-to-r from-accent-500/10 to-accent-600/10 rounded-xl opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                          </button>
                        </li>
                        {showRegister && (
                          <li>
                            <Link to="/registration" className="ml-4">
                              <button className='relative overflow-hidden bg-transparent border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:shadow-glow-primary hover:scale-105'>
                                Register Now
                              </button>
                            </Link>
                          </li>
                        )}
                        {isAuthenticated && (
                          <li>
                            <button 
                              className="relative group text-red-600 font-semibold px-6 py-3 rounded-xl transition-all duration-300 hover:bg-red-50 border-2 border-red-200 hover:border-red-300 flex items-center justify-center ml-4"
                              onClick={handleLogout}
                            >
                              <span className="relative z-10">Logout</span>
                            </button>
                          </li>
                        )}
                      </ul>
                      </nav>

                      {/* Mobile Menu Button */}
                      <button 
                        className="lg:hidden text-neutral-700 p-3 rounded-xl transition-all duration-300 hover:bg-neutral-100 active:scale-95 flex items-center justify-center"
                        onClick={toggleMobileMenu}
                        aria-label="Toggle mobile menu"
                      >
                        <div className="relative w-6 h-6">
                          <div className={`absolute inset-0 transition-all duration-300 ${isMobileMenuOpen ? 'rotate-180 opacity-0' : 'rotate-0 opacity-100'}`}>
                            <FaBars className="w-full h-full" />
                          </div>
                          <div className={`absolute inset-0 transition-all duration-300 ${isMobileMenuOpen ? 'rotate-0 opacity-100' : 'rotate-180 opacity-0'}`}>
                            <FaTimes className="w-full h-full" />
                          </div>
                        </div>
                      </button>
                  </div>

                  {/* Mobile Navigation Menu */}
                  <div className={`lg:hidden absolute top-full left-0 w-full transition-all duration-500 ease-in-out ${
                    isMobileMenuOpen 
                      ? 'opacity-100 translate-y-0 pointer-events-auto' 
                      : 'opacity-0 -translate-y-4 pointer-events-none'
                  }`}>
                    <div className="bg-white/90 backdrop-blur-xl border-t border-neutral-200/30 shadow-strong">
                      <nav className="container-custom py-6">
                        <ul className="space-y-2">
                      <li className="transform transition-all duration-300 hover:translate-x-2">
                        <Link 
                          to="/" 
                          className="block text-neutral-700 font-semibold hover:text-primary-600 transition-all duration-300 px-6 py-4 rounded-xl hover:bg-primary-50 mx-2 flex items-center group"
                          onClick={closeMobileMenu}
                        >
                          <div className="flex items-center space-x-3 w-full">
                            <div className="w-2 h-2 bg-primary-500 rounded-full opacity-60 group-hover:opacity-100 transition-opacity"></div>
                            <span>Home</span>
                          </div>
                        </Link>
                      </li>
                      <li className="transform transition-all duration-300 hover:translate-x-2">
                        <Link 
                          to="/events" 
                          className="block text-neutral-700 font-semibold hover:text-secondary-600 transition-all duration-300 px-6 py-4 rounded-xl hover:bg-secondary-50 mx-2 flex items-center group"
                          onClick={closeMobileMenu}
                        >
                          <div className="flex items-center space-x-3 w-full">
                            <div className="w-2 h-2 bg-secondary-500 rounded-full opacity-60 group-hover:opacity-100 transition-opacity"></div>
                            <span>Events</span>
                          </div>
                        </Link>
                      </li>
                      <li className="transform transition-all duration-300 hover:translate-x-2">
                        <button 
                          className="block w-full text-left text-neutral-700 font-semibold hover:text-accent-600 transition-all duration-300 px-6 py-4 rounded-xl hover:bg-accent-50 mx-2 flex items-center group"
                          onClick={handleContactClick}
                        >
                          <div className="flex items-center space-x-3 w-full">
                            <div className="w-2 h-2 bg-accent-500 rounded-full opacity-60 group-hover:opacity-100 transition-opacity"></div>
                            <span>Contact</span>
                          </div>
                        </button>
                      </li>
                      {showRegister && (
                        <li className="transform transition-all duration-300 hover:translate-x-2">
                          <Link 
                            to="/registration" 
                            className="block text-white px-6 py-4 mx-2 rounded-xl"
                            onClick={closeMobileMenu}
                          >
                            <div className="relative overflow-hidden bg-transparent border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white font-semibold px-6 py-3 rounded-xl transition-all duration-300 w-full text-center">
                              <span>Register Now</span>
                            </div>
                          </Link>
                        </li>
                      )}
                      {isAuthenticated && (
                        <li className="transform transition-all duration-300 hover:translate-x-2">
                          <button 
                            className="block w-full text-left text-red-600 font-semibold hover:text-red-700 transition-all duration-300 px-6 py-4 hover:bg-red-50 rounded-xl mx-2 border-2 border-red-200 hover:border-red-300 flex items-center group"
                            onClick={handleLogout}
                          >
                            <div className="flex items-center space-x-3 w-full">
                              <div className="w-2 h-2 bg-red-500 rounded-full opacity-60 group-hover:opacity-100 transition-opacity"></div>
                              <span>Logout</span>
                            </div>
                          </button>
                        </li>
                      )}
                        </ul>
                      </nav>
                    </div>
                  </div>
              </div>
          </header>
    </div>
  );
}

export default Header;
